import React, { useContext, useEffect, useRef, useState } from 'react';
import { EventContext } from '../context/EventContext';
import { getLogoDownloadUrl, uploadLogo } from '../services/logoService';
import { useToast } from '../context/ToastContext';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

const EventLogoComponent: React.FC = () => {
  const { currentEvent } = useContext(EventContext);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [logoUrl, setLogoUrl] = useState('');
  const toast = useToast();
  const navigate = useNavigate();


  if (!currentEvent) {
    return <p>Loading event details...</p>;
  }

  const { event_name, logo, event_id } = currentEvent;


  useEffect(() => {
    const fetchLogoUrl = async () => {
      if (logo) {
        try {
          const result = await getLogoDownloadUrl(event_id, logo);
          setLogoUrl(result);
        } catch (error) {
          toast.addToast("Error fetching logo", true);
          console.error('Error fetching logo download URL:', error);
        }
      }
    };

    fetchLogoUrl();
  }, [currentEvent]);

  const onBack = () => {
    navigate(ROUTES.EVENT_OVERVIEW);
  };


  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !event_id) return;
    setIsUploading(true);
    toast.addToast("Uploading, please don't click await");

    try {
      await uploadLogo(event_id, file);
      toast.addToast("Upload successful");

    } catch (error) {
      toast.addToast("Error uploading logo", true);
      console.error('Error uploading logo:', error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h1>{event_name}</h1>
      <div style={styles.logoContainer}>
        {logo ? (
          <img src={logoUrl} alt="Event Logo" style={styles.logo} />
        ) : (
          <div style={styles.placeholder}>No Logo Uploaded</div>
        )}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      <div style={styles.buttons} className="no-print">
        <button onClick={onBack} className='cancelButton' disabled={isUploading}>
          Back to Overview
        </button>
        <button onClick={handleUploadClick} disabled={isUploading}>
          {isUploading ? 'Uploading...' : logo ? 'Change Logo' : 'Upload Logo'}
        </button>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoContainer: {
    width: '400px',
    height: '400px',
    border: '2px dashed #ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '1rem 0',
    backgroundColor: '#fafafa',
  },
  logo: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  placeholder: {
    color: '#999',
    fontSize: '1.2rem',
  },
  buttons: {
    display: 'flex',
    gap: '5rem',
    marginTop: '0rem',
  },
};

export default EventLogoComponent;
